import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import background from 'asset/img/background3.webp';
import Loadding from 'components/Loadding';
import { setWelcomeSeen } from 'network';
import './index.scss';

const Welcome = () => {
  const navigate = useNavigate();
  const [loadingDone, setLoadingDone] = useState(false);

  // 进入 welcome 即标记（后端 welcome_seen + 本地 need_assessment_pending），用于未完成 s111 时下次登录/切回仍出现听力扫描
  useEffect(() => {
    setWelcomeSeen().catch(() => {});
    try {
      localStorage.setItem('need_assessment_pending', '1');
    } catch (e) {}
  }, []);

  // 首次注册登录：首屏不再展示右脑 loading，改为正常 loading，短暂展示后直接进入测试流程
  useEffect(() => {
    const hasFirstLoginLoading = sessionStorage.getItem('first_login_loading') === '1';
    if (!hasFirstLoginLoading) {
      setLoadingDone(true);
      return;
    }
    sessionStorage.removeItem('first_login_loading');
    const t = setTimeout(() => setLoadingDone(true), 1500);
    return () => clearTimeout(t);
  }, []);

  const handleEnter = () => {
    navigate('/detail?assessment=1&level=1');
  };

  if (!loadingDone) {
    return <Loadding visible />;
  }

  return (
    <div className="welcome-page">
      <img src={background} className="welcome-bg" alt="" />
      <div className="welcome-content">
        <div className="welcome-card">
          <h1 className="welcome-title">英语听力感知扫描</h1>
          <div className="welcome-desc">
            <div>1: AI出题，<span className="highlight">精准评估</span>小朋友听力水平</div>
            <div>2: 悟空会根据测试结果，开启专属右脑<span className="highlight">学习英语计划</span></div>
          </div>
          <button className="welcome-btn" onClick={handleEnter}>
            开始语言扫描
          </button>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
